module.exports = __webpack_public_path__ + "img/thumb_up.9b622942.svg";